import {Bar, Doughnut, Line} from "react-chartjs-2";
import {IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle} from "@ionic/react";
import React, {CSSProperties} from "react";
import {ArcElement, ChartData, ChartOptions, Legend, Tooltip} from "chart.js";
import Chart from 'chart.js/auto';
Chart.register(ArcElement, Tooltip, Legend);
export type ChartProps = {
	type?: 'line' | 'bar' | 'doughnut';
	chart: CarrierSummaryChart;
	style?: CSSProperties;
}
export type CarrierSummaryChart = {
	title: string;
	subtitle: string;
	data: ChartData<any, any, any>;
	options: ChartOptions<any>;
}

export default (props: ChartProps) => {
	const type = (props.type ?? 'bar');

	const handleGetData = (event:any) => {
		const chart = event.currentTarget;
		const xClick = Math.floor(
			chart.scales.x.getValueForPixel(event.clientX) + 1e-10
		); // floor and +1e-10 --- just to get rid of -0
		const barElement = chart.getDatasetMeta(0).data[xClick];


	};
	return (
		<IonCard style={props.style ?? props.style}>
			<IonCardHeader>
				<IonCardTitle>{props.chart.title}</IonCardTitle>
				<IonCardSubtitle>{props.chart.subtitle}</IonCardSubtitle>
			</IonCardHeader>
			<IonCardContent>
				{type === 'bar' &&
					<Bar data={props.chart.data} options={props.chart.options}/>
				}
				{type === 'line' &&
					<Line data={props.chart.data} options={props.chart.options}/>
				}
				{type === 'doughnut' &&
					<Doughnut data={props.chart.data} options={props.chart.options}  onClick={handleGetData} />
				}
			</IonCardContent>
		</IonCard>
	)
}